<script lang="ts">
import { usePromotions } from '@/composables/usePromotions'
import { DateTime } from 'luxon'
import { defineComponent } from 'vue'

/**
 * WelcomeBonusBanner
 */
export default defineComponent({
  props: {
    showCountdown: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { loadPromotions, showWelcomeBanner, promotionProgress } =
      usePromotions()

    return {
      loadPromotions,
      showWelcomeBanner,
      promotionProgress,
    }
  },
  computed: {
    expiry(): DateTime | null {
      const welcomeEntry = this.promotionProgress.find(
        (e) => e.code === 'welcome-deposit-match'
      )
      const expiry = welcomeEntry?.expires_at ?? null

      if (expiry) {
        return DateTime.fromISO(expiry)
      }

      return null
    },
  },
  mounted() {
    void this.loadPromotions()
  },
})
</script>

<template v-if="showWelcomeBanner">
  <div
    class="welcome-bonus-banner relative flex flex-col items-start self-stretch rounded-lg p-4 text-white bg-black min-h-fit @xs/main:m-0 @container/banner mask-squiggle"
    :style="{
      '--mask-squiggle-url': `url('/assets/images/masks/welcome-squiggle.svg')`,
    }"
  >
    <!-- Content -->
    <div class="flex flex-col items-center text-center w-full h-full">
      <h2
        class="text-xl font-black uppercase tracking-wide mb-2 @[246px]/banner:text-2xl"
      >
        DOUBLE YOUR MONEY
      </h2>

      <slot name="subtitle">
        <p class="text-base @[246px]/banner:text-xl font-black mb-3 leading-5">
          We'll match your first deposit!
        </p>
      </slot>

      <slot name="deposit-button" />

      <div
        v-if="showCountdown && expiry"
        class="flex items-center gap-1 self-stretch mt-auto"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="10" stroke-width="2" />
          <path d="M12 6v6l4 2" stroke-width="2" stroke-linecap="round" />
        </svg>

        <span class="text-sm font-medium">Ends in</span>

        <AppCountdown
          :datetime="expiry"
          :show-all-units="false"
          time-class="text-sm font-bold"
          unit-class="text-sm font-bold"
          class="gap-1"
        />

        <p
          class="ml-auto text-sm opacity-90 text-right leading-4 capitalize font-[450]"
        >
          T&Cs Apply
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.welcome-bonus-banner {
  :deep(button[title='Claim Bonus']) {
    @apply mt-0 @[246px]:mt-1 @[246px]:mb-4 @[246px]:text-base !min-w-full !leading-none justify-center text-sm !font-bold;
  }
}
</style>
